import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Toasts from "../../../core/common/toast";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { getLogin } from "../../../core/data/redux/adminAuthSlice";
import "./employeeLogin.css";

type PasswordField = "password";

const schema = Yup.object().shape({
  username: Yup.string().required("Username is required"),
  password: Yup.string()
    .min(6, "Minimum 6 characters")
    .max(15, "Maximum 15 characters allowed")
    .required("Password is required"),
});

const Login = () => {

  const dispatch = useDispatch();
  const employeeAuthState = useSelector(
    (state: any) => state.adminAuthState
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const routes = all_routes;
  const navigation = useNavigate();

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onSubmit = (data: any) => {
    dispatch(getLogin({ ...data, action: "ADMIN_LOGIN" }));
  };

  useEffect(() => {
    if (
      employeeAuthState.loading === "fulfilled" &&
      employeeAuthState.action === "employee-login"
    ) {
      navigation(routes.adminTwoStepVerification);
    }
  }, [employeeAuthState.loading]);

  return (
    <>
      <Toasts
        show={employeeAuthState.loading === "rejected"}
        message={employeeAuthState.error}
        title={"Login Failed"}
        type={"danger"}
      />
      <div className="hero">
        <div className="sub-hero">
          <div className="img-logo">
            <img src="/assets/img/login/logo.png" alt="logoimage" />
          </div>
          <p className="text-white fs-3  fw-bold sub-title text-center">
            Admin Login
          </p>
          {/* Form */}
          <div className="">
            <form onSubmit={handleSubmit(onSubmit)} className="form-container">
              <div className="form-group">
                <label htmlFor="username" className="">
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  className={`form-input ${errors.username ? "error" : ""}`}
                  placeholder="username"
                  maxLength={8}
                  {...register("username")}
                />
                {errors.username && (
                  <span className="error-message">
                    {errors.username.message}
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="password" className="">
                  Password
                </label>
                <div className="password-input-container">
                  <input
                    type={passwordVisibility.password ? "text" : "password"}
                    id="password"
                    className={`form-input ${errors.password ? "error" : ""}`}
                    placeholder="********"
                    maxLength={15}
                    // minLength={6}
                    {...register("password")}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => togglePasswordVisibility("password")}
                  >
                    {passwordVisibility.password ? (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-eye-icon lucide-eye"
                        >
                          <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </>
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-eye-off-icon lucide-eye-off"
                        >
                          <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
                          <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
                          <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
                          <path d="m2 2 20 20" />
                        </svg>
                      </>
                    )}
                  </button>
                </div>
                {errors.password && (
                  <span className="error-message">
                    {errors.password.message}
                  </span>
                )}
              </div>
              <div className="forgot-password">

                Forgot Password?
                <p>
                  <Link
                    to={all_routes.adminForgotPassword}
                    className="reset-password"
                  >
                    Click Here
                  </Link>
                </p>
              </div>
              <button
                type="submit"
                className="submit-btn"
                disabled={employeeAuthState.loading === "pending"}
              >
                {employeeAuthState.loading === "pending"
                  ? "Signing In..."
                  : "Sign In"}
              </button>
              <p className="terms-text">
                By clicking on Sign In, you agree to our Terms of service and
                Privacy Policy
              </p>
            </form>
          </div>
        </div>
        <div className="right-img">
          <div className="ladies-img">
            <img src="/assets/img/login/ladies.png" alt="" />
          </div>
          <div className="metro-img">
            <img src="/assets/img/login/metroo.png" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
